import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function TenantListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            deleteModalTitile={"Delete Tenant"}
                            deleteModalQuestion={"Are you sure you want to delete this Tenant?"}
                            editHref={"/tenant/update"}
                            detailsHref={"/tenant/details"}
                            objectKeys={["id", "name", "external_id"]}
                            columnTitles={[
                                "ID", "Name", "External ID"
                            ]}
                            insertHref={"/tenant/create"}
                            insertTitle={"Add Tenant"}
                            pageTitle={"Tenants"}
                            deleteEndpoint={"tenant/delete"}
                            readEndpoint={"tenant/read"}
                            />
        </>
    )
}

export default TenantListPage;